import { Component, OnInit } from '@angular/core';
import { ButtonsComponent } from 'gung-standard';
@Component({
  selector: 'tylo-buttons',
  templateUrl: './tylo-buttons.component.html',
  styleUrls: ['./tylo-buttons.component.css']
})
export class TyloButtonsComponent extends ButtonsComponent implements OnInit {}
